<div class="container">

  @if (children === null) {
  <app-loader [message]="'Chargement...'" class="margin"></app-loader>
  } @else if (children.length === 0) {
  <div class="empty-state">
    <mat-icon>child_care</mat-icon>
    <p>Aucun enfant associé à ce compte.</p>
  </div>
  } @else {

  <!-- ─── Barre supérieure : enfant + date ─── -->
  <div class="top-bar">

    @if (children.length > 1) {
    <button class="child-selector-btn" [matMenuTriggerFor]="childMenu">
      @if (selectedChild) {
      <mat-icon color="primary">child_care</mat-icon>
      <span class="child-name">{{ selectedChild.prenom }} {{ selectedChild.nom }}</span>
      } @else {
      <mat-icon class="child-placeholder-icon">child_care</mat-icon>
      <span class="child-name">Choisir...</span>
      }
      <mat-icon class="caret">expand_more</mat-icon>
    </button>
    <mat-menu #childMenu="matMenu">
      @for (child of children; track child.id) {
      <button mat-menu-item (click)="selectChild(child)" class="child-menu-item"
        [class.is-selected]="selectedChild?.id === child.id">
        <div class="item-label">
          <span>{{ child.prenom }} {{ child.nom }}</span>
        </div>
      </button>
      }
    </mat-menu>
    } @else if (selectedChild) {
    <div class="child-selector-btn static">
      <mat-icon color="primary">child_care</mat-icon>
      <span class="child-name">{{ selectedChild.prenom }} {{ selectedChild.nom }}</span>
    </div>
    }

    <div class="date-nav-wrapper" [class.is-disabled]="!selectedChild" [class.has-toggle]="entry && config">
      <button mat-icon-button class="nav-btn" (click)="prevDay()" matTooltip="Jour précédent">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <mat-form-field appearance="outline" class="date-field" subscriptSizing="dynamic">
        <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" [max]="today"
          (dateChange)="onDateChange($event.value)" readonly>
        <mat-datepicker-toggle matIconPrefix [for]="picker">
          <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <button mat-icon-button class="nav-btn" (click)="nextDay()" [disabled]="isNextDayDisabled"
        matTooltip="Jour suivant">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    @if (entry && config) {
    <div class="toggle-panels-wrapper">
      <button mat-icon-button (click)="toggleAllPanels()" [matTooltip]="allExpanded ? 'Tout replier' : 'Tout déplier'">
        <mat-icon>{{ allExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
      </button>
    </div>
    }
  </div>

  <!-- ─── Zone de contenu ─── -->
  @if (!selectedChild) {
  <div class="empty-state">
    <mat-icon>touch_app</mat-icon>
    <p>Sélectionnez un enfant pour consulter son carnet de liaison.</p>
  </div>
  } @else if (isLoading) {
  <app-loader [message]="'Chargement du carnet...'" class="margin"></app-loader>
  } @else if (hasNoEntry) {
  <div class="empty-state">
    <mat-icon>event_busy</mat-icon>
    <p>Aucune entrée pour ce jour.</p>
    <span class="empty-hint">Ce jour n'a pas encore de données enregistrées.</span>
  </div>
  } @else if (firstDAOnly && config) {
  <div class="section-label">
    <mat-icon>trending_up</mat-icon>
    <span>Développement et acquisitions</span>
  </div>
  <mat-accordion multi class="sections">
    @if (config.developpement.psychomoteur.enable && firstDAOnly.DA_devPsychomoteur?.length) {
    <mat-expansion-panel class="section-panel panel-dev" [style]="getPanelStyle('psychomoteur')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.developpement.psychomoteur.typeIcon"
              [icon]="config.developpement.psychomoteur.icon" [size]="20"></app-icon></div>
          Développement psychomoteur
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-dev-psychomoteur [data]="null" [firstDA]="firstDAOnly" [selectedDate]="selectedDate" />
    </mat-expansion-panel>
    }
    @if (config.developpement.langage.enable && firstDAOnly.DA_acquisitionLangage?.length) {
    <mat-expansion-panel class="section-panel panel-langage" [style]="getPanelStyle('langage')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.developpement.langage.typeIcon"
              [icon]="config.developpement.langage.icon" [size]="20"></app-icon></div>
          Acquisition du langage
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-langage [data]="null" [firstDA]="firstDAOnly" [selectedDate]="selectedDate" />
    </mat-expansion-panel>
    }
    @if (config.developpement.diversification.enable && firstDAOnly.DA_diversification?.length) {
    <mat-expansion-panel class="section-panel panel-diversification" [style]="getPanelStyle('diversification')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.developpement.diversification.typeIcon"
              [icon]="config.developpement.diversification.icon" [size]="20"></app-icon></div>
          Diversification alimentaire
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-diversification [data]="null" [firstDA]="firstDAOnly" [selectedDate]="selectedDate" />
    </mat-expansion-panel>
    }
    @if (config.developpement.physiologique.enable && firstDAOnly.DA_devPhysiquePhysiologique?.length) {
    <mat-expansion-panel class="section-panel panel-physio" [style]="getPanelStyle('physiologique')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.developpement.physiologique.typeIcon"
              [icon]="config.developpement.physiologique.icon" [size]="20"></app-icon></div>
          Développement physique et physiologique
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-dev-physiologique [data]="null" [firstDA]="firstDAOnly" [selectedDate]="selectedDate" />
    </mat-expansion-panel>
    }
  </mat-accordion>
  } @else if (entry && config) {

  <!-- ══════ Transmission quotidienne ══════ -->
  @if (
  (config.transmission.transmissionParent.enable && entry.TQ_transmissionParent) ||
  (config.transmission.repas.enable && entry.TQ_repas) ||
  (config.transmission.sommeil.enable && entry.TQ_sommeil) ||
  (config.transmission.hygiene.enable && entry.TQ_hygieneChange) ||
  (config.transmission.activite.enable && entry.TQ_activite) ||
  (config.transmission.momentDeVie.enable && entry.TQ_momentDeVie) ||
  (config.transmission.traitement.enable && entry.TQ_traitement) ||
  (config.transmission.transmissionPro.enable && entry.TQ_transmissionProfessionnelle)
  ) {
  <div class="section-label">
    <mat-icon>today</mat-icon>
    <span>Transmission quotidienne</span>
  </div>
  <mat-accordion multi class="sections">

    <!-- TRANSMISSION PARENT -->
    @if (config.transmission.transmissionParent.enable && entry.TQ_transmissionParent) {
    <mat-expansion-panel class="section-panel panel-famille" [style]="getPanelStyle('transmissionParent')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.transmission.transmissionParent.typeIcon"
              [icon]="config.transmission.transmissionParent.icon" [size]="20"></app-icon></div>
          Transmission parent
        </mat-panel-title>
        @if (entry.TQ_transmissionParent.ongletTransmission.input_heureArrivee) {
        <mat-panel-description class="panel-desc">
          <mat-icon class="desc-icon">schedule</mat-icon>
          {{ entry.TQ_transmissionParent.ongletTransmission.input_heureArrivee | carnetHeure }}
        </mat-panel-description>
        }
      </mat-expansion-panel-header>
      <app-carnet-transmission-parent [data]="entry.TQ_transmissionParent" />
    </mat-expansion-panel>
    }

    <!-- REPAS -->
    @if (config.transmission.repas.enable && entry.TQ_repas) {
    <mat-expansion-panel class="section-panel panel-repas" [style]="getPanelStyle('repas')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.transmission.repas.typeIcon"
              [icon]="config.transmission.repas.icon" [size]="20"></app-icon></div>
          Repas
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-repas [data]="entry.TQ_repas" />
    </mat-expansion-panel>
    }

    <!-- SOMMEIL -->
    @if (config.transmission.sommeil.enable && entry.TQ_sommeil) {
    <mat-expansion-panel class="section-panel panel-sommeil" [style]="getPanelStyle('sommeil')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.transmission.sommeil.typeIcon"
              [icon]="config.transmission.sommeil.icon" [size]="20"></app-icon></div>
          Sommeil
        </mat-panel-title>
        @if (entry.TQ_sommeil.ongletSommeil.input_rituelParticulier) {
        <mat-panel-description class="panel-desc">
          <mat-icon class="desc-icon">auto_fix_high</mat-icon>
          {{ entry.TQ_sommeil.ongletSommeil.input_rituelParticulier }}
        </mat-panel-description>
        }
      </mat-expansion-panel-header>
      <app-carnet-sommeil [data]="entry.TQ_sommeil" />
    </mat-expansion-panel>
    }

    <!-- HYGIÈNE / CHANGES -->
    @if (config.transmission.hygiene.enable && entry.TQ_hygieneChange) {
    <mat-expansion-panel class="section-panel panel-hygiene" [style]="getPanelStyle('hygiene')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.transmission.hygiene.typeIcon"
              [icon]="config.transmission.hygiene.icon" [size]="20"></app-icon></div>
          Hygiène et changes
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-hygiene [data]="entry.TQ_hygieneChange" />
    </mat-expansion-panel>
    }

    <!-- ACTIVITÉS -->
    @if (config.transmission.activite.enable && entry.TQ_activite) {
    <mat-expansion-panel class="section-panel panel-activite" [style]="getPanelStyle('activite')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.transmission.activite.typeIcon"
              [icon]="config.transmission.activite.icon" [size]="20"></app-icon></div>
          Activités
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-activite [data]="entry.TQ_activite" />
    </mat-expansion-panel>
    }

    <!-- MOMENT DE VIE -->
    @if (config.transmission.momentDeVie.enable && entry.TQ_momentDeVie) {
    <mat-expansion-panel class="section-panel panel-vie" [style]="getPanelStyle('momentDeVie')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.transmission.momentDeVie.typeIcon"
              [icon]="config.transmission.momentDeVie.icon" [size]="20"></app-icon></div>
          Moment de vie
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-moment-de-vie [data]="entry.TQ_momentDeVie" />
    </mat-expansion-panel>
    }

    <!-- TRAITEMENTS -->
    @if (config.transmission.traitement.enable && entry.TQ_traitement) {
    <mat-expansion-panel class="section-panel panel-traitement" [style]="getPanelStyle('traitement')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.transmission.traitement.typeIcon"
              [icon]="config.transmission.traitement.icon" [size]="20"></app-icon></div>
          Traitements
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-traitement [data]="entry.TQ_traitement" />
    </mat-expansion-panel>
    }

    <!-- TRANSMISSION PROFESSIONNEL -->
    @if (config.transmission.transmissionPro.enable && entry.TQ_transmissionProfessionnelle) {
    <mat-expansion-panel class="section-panel panel-pro" [style]="getPanelStyle('transmissionPro')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.transmission.transmissionPro.typeIcon"
              [icon]="config.transmission.transmissionPro.icon" [size]="20"></app-icon></div>
          Message du professionnel
        </mat-panel-title>
        @if (entry.TQ_transmissionProfessionnelle.input_heure) {
        <mat-panel-description class="panel-desc">
          <mat-icon class="desc-icon">schedule</mat-icon>
          {{ entry.TQ_transmissionProfessionnelle.input_heure | carnetHeure }}
        </mat-panel-description>
        }
      </mat-expansion-panel-header>
      <app-carnet-transmission-pro [data]="entry.TQ_transmissionProfessionnelle" />
    </mat-expansion-panel>
    }

  </mat-accordion>
  }

  <!-- ══════ Développement et acquisitions ══════ -->
  @if (
  (config.developpement.psychomoteur.enable && entry.DA_devPsychomoteur) ||
  (config.developpement.langage.enable && entry.DA_acquisitionLangage) ||
  (config.developpement.diversification.enable && entry.DA_diversification) ||
  (config.developpement.physiologique.enable && entry.DA_devPhysiquePhysiologique)
  ) {
  <div class="section-label">
    <mat-icon>trending_up</mat-icon>
    <span>Développement et acquisitions</span>
  </div>
  <mat-accordion multi class="sections">

    <!-- DÉVELOPPEMENT PSYCHOMOTEUR -->
    @if (config.developpement.psychomoteur.enable && entry.DA_devPsychomoteur) {
    <mat-expansion-panel class="section-panel panel-dev" [style]="getPanelStyle('psychomoteur')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.developpement.psychomoteur.typeIcon"
              [icon]="config.developpement.psychomoteur.icon" [size]="20"></app-icon></div>
          Développement psychomoteur
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-dev-psychomoteur [data]="entry.DA_devPsychomoteur" [firstDA]="entry.FirstDA ?? null" [selectedDate]="selectedDate" />
    </mat-expansion-panel>
    }

    <!-- ACQUISITION DU LANGAGE -->
    @if (config.developpement.langage.enable && entry.DA_acquisitionLangage) {
    <mat-expansion-panel class="section-panel panel-langage" [style]="getPanelStyle('langage')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.developpement.langage.typeIcon"
              [icon]="config.developpement.langage.icon" [size]="20"></app-icon></div>
          Acquisition du langage
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-langage [data]="entry.DA_acquisitionLangage" [firstDA]="entry.FirstDA ?? null" [selectedDate]="selectedDate" />
    </mat-expansion-panel>
    }

    <!-- DIVERSIFICATION ALIMENTAIRE -->
    @if (config.developpement.diversification.enable && entry.DA_diversification) {
    <mat-expansion-panel class="section-panel panel-diversification" [style]="getPanelStyle('diversification')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.developpement.diversification.typeIcon"
              [icon]="config.developpement.diversification.icon" [size]="20"></app-icon></div>
          Diversification alimentaire
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-diversification [data]="entry.DA_diversification" [firstDA]="entry.FirstDA ?? null" [selectedDate]="selectedDate" />
    </mat-expansion-panel>
    }

    <!-- DÉVELOPPEMENT PHYSIQUE / PHYSIOLOGIQUE -->
    @if (config.developpement.physiologique.enable && entry.DA_devPhysiquePhysiologique) {
    <mat-expansion-panel class="section-panel panel-physio" [style]="getPanelStyle('physiologique')">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="icon-badge"><app-icon [type]="config.developpement.physiologique.typeIcon"
              [icon]="config.developpement.physiologique.icon" [size]="20"></app-icon></div>
          Développement physique et physiologique
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-carnet-dev-physiologique [data]="entry.DA_devPhysiquePhysiologique" [firstDA]="entry.FirstDA ?? null" [selectedDate]="selectedDate" />
    </mat-expansion-panel>
    }

  </mat-accordion>
  }

  }

  }

</div>